import dayjs from 'dayjs';

export const QUERY_FORMATTERS = {
  date: (value) => dayjs(value).format('YYYY-MM-DD'),
};
